import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { ProgramClient } from "../../parentApi";

const client = new ProgramClient(app_uri, axiosClient());

export default client;
